import { GridActionsCellItem, GridRowParams } from '@mui/x-data-grid';

import './styles.css';

const DetailsIcon = () => (
  <svg
    fill='none'
    height='14'
    viewBox='0 0 16 14'
    width='16'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15.8041 6.19502L9.80446 0.195356C9.67937 0.0702694 9.50972 -4.05931e-06 9.33282 -4.09025e-06C9.15592 -4.12117e-06 8.98626 0.0702692 8.86117 0.195356C8.73609 0.320443 8.66581 0.490098 8.66581 0.666997C8.66581 0.843896 8.73609 1.01355 8.86117 1.13864L13.7234 6.00003L0.666631 6.00003C0.48983 6.00003 0.32027 6.07027 0.195253 6.19528C0.0702353 6.3203 1.19655e-06 6.48986 1.16564e-06 6.66666C1.13472e-06 6.84346 0.0702352 7.01302 0.195252 7.13804C0.32027 7.26306 0.489829 7.33329 0.666631 7.33329L13.7234 7.33329L8.86117 12.1947C8.73609 12.3198 8.66581 12.4894 8.66581 12.6663C8.66581 12.8432 8.73609 13.0129 8.86117 13.138C8.98626 13.2631 9.15591 13.3333 9.33281 13.3333C9.50971 13.3333 9.67937 13.2631 9.80445 13.138L15.8041 7.13831C15.8661 7.07639 15.9153 7.00287 15.9488 6.92194C15.9824 6.84102 15.9996 6.75427 15.9996 6.66667C15.9996 6.57906 15.9824 6.49231 15.9488 6.41139C15.9153 6.33046 15.8661 6.25694 15.8041 6.19502Z'
      fill='#181818'
    />
  </svg>
);

const EditIcon = () => (
  <svg
    fill='none'
    height='16'
    viewBox='0 0 16 16'
    width='16'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M15.6268 3.94945L12.0515 0.375011C11.9327 0.25612 11.7915 0.161808 11.6362 0.0974633C11.4809 0.0331183 11.3144 0 11.1463 0C10.9782 0 10.8117 0.0331183 10.6564 0.0974633C10.5011 0.161808 10.36 0.25612 10.2411 0.375011L0.376187 10.2399C0.25681 10.3584 0.162164 10.4993 0.0977515 10.6547C0.0333392 10.81 0.000445805 10.9766 0.000983039 11.1447V14.72C0.000983039 15.0595 0.135841 15.385 0.375891 15.6251C0.61594 15.8651 0.941517 16 1.281 16H14.7212C14.8909 16 15.0537 15.9326 15.1737 15.8125C15.2937 15.6925 15.3612 15.5297 15.3612 15.36C15.3612 15.1903 15.2937 15.0275 15.1737 14.9074C15.0537 14.7874 14.8909 14.72 14.7212 14.72H6.66666L15.6268 5.75988C15.7457 5.64101 15.84 5.49989 15.9043 5.34457C15.9687 5.18926 16.0018 5.02278 16.0018 4.85466C16.0018 4.68655 15.9687 4.52007 15.9043 4.36476C15.84 4.20944 15.7457 4.06832 15.6268 3.94945ZM4.85624 14.72H1.281V11.1447L8.32108 4.10466L11.8963 7.6799L4.85624 14.72ZM12.8011 6.77509L9.22669 3.19985L11.1467 1.27982L14.7212 4.85507L12.8011 6.77509Z'
      fill='black'
    />
  </svg>
);

const DeleteIcon = () => (
  <svg
    fill='none'
    height='16'
    viewBox='0 0 15 16'
    width='15'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M14.3863 2.46154H11.3093V1.84615C11.3093 1.35652 11.1148 0.886947 10.7686 0.540726C10.4224 0.194505 9.95282 0 9.46319 0H5.77088C5.28125 0 4.81168 0.194505 4.46546 0.540726C4.11923 0.886947 3.92473 1.35652 3.92473 1.84615V2.46154H0.847806C0.684596 2.46154 0.528071 2.52637 0.412664 2.64178C0.297257 2.75719 0.232422 2.91371 0.232422 3.07692C0.232422 3.24013 0.297257 3.39666 0.412664 3.51207C0.528071 3.62747 0.684596 3.69231 0.847806 3.69231H1.46319V14.7692C1.46319 15.0957 1.59286 15.4087 1.82367 15.6395C2.05449 15.8703 2.36754 16 2.69396 16H12.5401C12.8665 16 13.1796 15.8703 13.4104 15.6395C13.6412 15.4087 13.7709 15.0957 13.7709 14.7692V3.69231H14.3863C14.5495 3.69231 14.706 3.62747 14.8214 3.51207C14.9368 3.39666 15.0017 3.24013 15.0017 3.07692C15.0017 2.91371 14.9368 2.75719 14.8214 2.64178C14.706 2.52637 14.5495 2.46154 14.3863 2.46154ZM5.1555 1.84615C5.1555 1.68294 5.22033 1.52642 5.33574 1.41101C5.45115 1.2956 5.60767 1.23077 5.77088 1.23077H9.46319C9.6264 1.23077 9.78293 1.2956 9.89833 1.41101C10.0137 1.52642 10.0786 1.68294 10.0786 1.84615V2.46154H5.1555V1.84615ZM12.5401 14.7692H2.69396V3.69231H12.5401V14.7692ZM6.38627 6.76923V11.6923C6.38627 11.8555 6.32143 12.012 6.20603 12.1275C6.09062 12.2429 5.93409 12.3077 5.77088 12.3077C5.60767 12.3077 5.45115 12.2429 5.33574 12.1275C5.22033 12.012 5.1555 11.8555 5.1555 11.6923V6.76923C5.1555 6.60602 5.22033 6.4495 5.33574 6.33409C5.45115 6.21868 5.60767 6.15385 5.77088 6.15385C5.93409 6.15385 6.09062 6.21868 6.20603 6.33409C6.32143 6.4495 6.38627 6.60602 6.38627 6.76923ZM10.0786 6.76923V11.6923C10.0786 11.8555 10.0137 12.012 9.89833 12.1275C9.78293 12.2429 9.6264 12.3077 9.46319 12.3077C9.29998 12.3077 9.14345 12.2429 9.02805 12.1275C8.91264 12.012 8.84781 11.8555 8.84781 11.6923V6.76923C8.84781 6.60602 8.91264 6.4495 9.02805 6.33409C9.14345 6.21868 9.29998 6.15385 9.46319 6.15385C9.6264 6.15385 9.78293 6.21868 9.89833 6.33409C10.0137 6.4495 10.0786 6.60602 10.0786 6.76923Z'
      fill='#A91D54'
    />
  </svg>
);

const DmsIcon = () => (
  <svg
    fill='none'
    height='16'
    viewBox='0 0 16 16'
    width='16'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1.33333 2H14.6667C15.0203 2 15.3594 2.14048 15.6095 2.39052C15.8595 2.64057 16 2.97971 16 3.33333V12.6667C16 13.0203 15.8595 13.3594 15.6095 13.6095C15.3594 13.8595 15.0203 14 14.6667 14H1.33333C0.979711 14 0.640573 13.8595 0.390524 13.6095C0.140476 13.3594 0 13.0203 0 12.6667V3.33333C0 2.97971 0.140476 2.64057 0.390524 2.39052C0.640573 2.14048 0.979711 2 1.33333 2ZM1.33333 5.33333V12.6667H14.6667V5.33333H1.33333ZM1.33333 3.33333V4H14.6667V3.33333H1.33333ZM3 8H7V9.33333H3V8Z'
      fill='#181818'
    />
  </svg>
);

const RefundIcon = () => (
  <svg
    fill='none'
    height='17'
    viewBox='0 0 20 17'
    width='20'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M19.1916 10.2532C18.9436 10.0624 18.6549 9.93131 18.348 9.87018C18.0411 9.80906 17.7242 9.81953 17.4219 9.90078L13.9359 10.7023C14.017 10.3597 14.0195 10.0032 13.9432 9.65945C13.867 9.31573 13.7139 8.99374 13.4955 8.7176C13.277 8.44147 12.9989 8.21835 12.682 8.06498C12.3651 7.91161 12.0176 7.83195 11.6655 7.83199H7.4946C7.14433 7.83111 6.79736 7.89965 6.47373 8.03365C6.15011 8.16765 5.85624 8.36445 5.60912 8.61268L3.72446 10.4982H1.33407C0.980508 10.4982 0.641432 10.6386 0.391429 10.8886C0.141427 11.1386 0.000976563 11.4777 0.000976562 11.8313L0.000976563 15.164C0.000976563 15.5175 0.141427 15.8566 0.391429 16.1066C0.641432 16.3566 0.980508 16.4971 1.33407 16.4971H9.99914C10.0536 16.4971 10.1079 16.4904 10.1608 16.4771L15.4931 15.144C15.5271 15.1359 15.5603 15.1247 15.5923 15.1107L18.8309 13.7326L18.8675 13.7159C19.1788 13.5604 19.4453 13.3282 19.642 13.0412C19.8387 12.7542 19.9591 12.4218 19.9919 12.0754C20.0246 11.729 19.9687 11.38 19.8292 11.0612C19.6898 10.7424 19.4715 10.4643 19.195 10.2532H19.1916ZM1.33407 11.8313H3.3337V15.164H1.33407V11.8313ZM18.2835 12.5153L15.1174 13.8634L9.91583 15.164H4.66679V11.4405L6.55228 9.55584C6.67562 9.43151 6.82244 9.33294 6.98421 9.26586C7.14598 9.19878 7.31948 9.16452 7.4946 9.16508H11.6655C11.9307 9.16508 12.185 9.27042 12.3725 9.45792C12.56 9.64542 12.6653 9.89973 12.6653 10.1649C12.6653 10.4301 12.56 10.6844 12.3725 10.8719C12.185 11.0594 11.9307 11.1647 11.6655 11.1647H9.3326C9.15582 11.1647 8.98628 11.2349 8.86128 11.3599C8.73628 11.4849 8.66605 11.6545 8.66605 11.8313C8.66605 12.008 8.73628 12.1776 8.86128 12.3026C8.98628 12.4276 9.15582 12.4978 9.3326 12.4978H11.9988C12.0489 12.4977 12.099 12.4921 12.1479 12.4811L17.7302 11.1972L17.7561 11.1905C17.9265 11.1432 18.1084 11.1606 18.2667 11.2394C18.4251 11.3181 18.5487 11.4526 18.6139 11.617C18.679 11.7814 18.6811 11.9641 18.6196 12.13C18.5581 12.2958 18.4375 12.4331 18.281 12.5153H18.2835ZM13.6651 6.4989C13.8298 6.49909 13.9942 6.48571 14.1567 6.45891C14.3395 7.00176 14.6739 7.48094 15.1203 7.83978C15.5668 8.19862 16.1066 8.42212 16.6761 8.48385C17.2456 8.54559 17.8208 8.44298 18.3338 8.18816C18.8468 7.93334 19.2761 7.53696 19.5709 7.04589C19.8658 6.55481 20.0138 5.98958 19.9976 5.41702C19.9814 4.84445 19.8016 4.2885 19.4795 3.81489C19.1573 3.34128 18.7063 2.96982 18.1797 2.74442C17.6531 2.51902 17.073 2.44911 16.5079 2.54296C16.332 2.01993 16.0151 1.55558 15.5922 1.20102C15.1694 0.84646 14.6569 0.615431 14.1112 0.533359C13.5655 0.451287 13.0077 0.521352 12.4993 0.735845C11.9908 0.950337 11.5514 1.30094 11.2293 1.74908C10.9073 2.19721 10.7151 2.7255 10.674 3.2758C10.6328 3.82611 10.7443 4.3771 10.9961 4.86814C11.2479 5.35919 11.6303 5.77124 12.1012 6.05896C12.5721 6.34668 13.1133 6.49891 13.6651 6.4989ZM18.6642 5.49908C18.6642 5.82866 18.5665 6.15083 18.3834 6.42487C18.2003 6.6989 17.94 6.91248 17.6355 7.0386C17.3311 7.16473 16.996 7.19772 16.6728 7.13343C16.3495 7.06913 16.0526 6.91043 15.8196 6.67738C15.5865 6.44434 15.4278 6.14742 15.3635 5.82418C15.2992 5.50093 15.3322 5.16588 15.4583 4.8614C15.5845 4.55691 15.798 4.29666 16.0721 4.11356C16.3461 3.93045 16.6683 3.83272 16.9979 3.83272C17.4398 3.83272 17.8637 4.00829 18.1762 4.32079C18.4887 4.63329 18.6642 5.05714 18.6642 5.49908ZM13.6651 1.83309C14.0287 1.83327 14.3822 1.95232 14.6717 2.17209C14.9613 2.39186 15.171 2.7003 15.269 3.05037C14.9276 3.29057 14.6401 3.59938 14.4249 3.95705C14.2097 4.31471 14.0716 4.71336 14.0192 5.12749C13.9029 5.15262 13.7842 5.16546 13.6651 5.16581C13.2232 5.16581 12.7993 4.99025 12.4868 4.67775C12.1743 4.36524 11.9988 3.9414 11.9988 3.49945C11.9988 3.05751 12.1743 2.63366 12.4868 2.32116C12.7993 2.00865 13.2232 1.83309 13.6651 1.83309Z'
      fill='#181818'
    />
  </svg>
);

type HandlerType<T> = (row: T) => void;

function useActionColumn<T>({
  handleDelete,
  handleEdit,
  handleRefund,
  handleDetails,
  handleReportToDms,
  shouldDisableRefund,
  shouldDisableDelete,
}: {
  handleDelete?: HandlerType<T>;
  handleEdit?: HandlerType<T>;
  handleRefund?: HandlerType<T>;
  handleDetails?: HandlerType<T>;
  handleReportToDms?: HandlerType<T>;
  shouldDisableRefund?: (row: T) => boolean;
  shouldDisableDelete?: (row: T) => boolean;
}) {
  return {
    field: 'actions',
    headerName: 'Action',
    headerClassName: 'text-site-gray-100 font-roboto-bold',
    type: 'actions',
    flex: 0.1,
    getActions: ({ row }: GridRowParams) => {
      const menuBtnArray = [];

      if (handleReportToDms) {
        menuBtnArray.push(
          <GridActionsCellItem
            showInMenu
            icon={<DmsIcon />}
            label='Report to DMS'
            onClick={() => handleReportToDms(row)}
          />
        );
      }

      if (handleRefund) {
        menuBtnArray.push(
          <GridActionsCellItem
            showInMenu
            disabled={shouldDisableRefund ? shouldDisableRefund(row) : false}
            icon={<RefundIcon />}
            label='Refund'
            onClick={() => handleRefund(row)}
          />
        );
      }

      if (handleDetails) {
        menuBtnArray.push(
          <GridActionsCellItem
            showInMenu
            icon={<DetailsIcon />}
            label='View Details'
            onClick={() => handleDetails(row)}
          />
        );
      }

      if (handleEdit) {
        menuBtnArray.push(
          <GridActionsCellItem
            showInMenu
            icon={<EditIcon />}
            label='Edit'
            onClick={() => handleEdit(row)}
          />
        );
      }

      if (handleDelete) {
        menuBtnArray.push(
          <GridActionsCellItem
            showInMenu
            disabled={shouldDisableDelete ? shouldDisableDelete(row) : false}
            icon={<DeleteIcon />}
            label='Delete'
            onClick={() => handleDelete(row)}
          />
        );
      }

      return menuBtnArray;
    },
  };
}

export default useActionColumn;
